import React from "react";

import { Box, Loader } from "@braintrust/braintrust-ui-components";

export const BidTabLoader = () => {
  return (
    <Box sx={{ position: "relative", minHeight: "200px" }}>
      <Loader centered />
    </Box>
  );
};
